import React from 'react';
import {Grid, Segment, List} from 'semantic-ui-react';
import './Content.css';

export default (props) => {
    return (
        <Grid> 
            <Grid.Row className="content-row" >
                <Grid.Column>
                    <Segment textAlign="center" style={{padding: 0, margin: 0, paddingBottom: "auto"}} basic clearing className="content-container-wrapper">
                        {props.children}
                    </Segment>
                </Grid.Column>
            </Grid.Row>
            <Grid.Row className="footer-container" centered>
                <List style={{verticalAlign: "center"}}>
                    <List.Item style={{marginBottom: "6px"}}>
                        {props.selectedLanguage === "lithuanian"? <span><b style={{fontWeight: 900, fontStyle: "none"}}>{props.lang.company_label}</b></span> : <span><i style={{fontWeight: 900}}>{props.lang.company_label}</i></span>}
                    </List.Item>

                    <List.Item style={{marginBottom: "6px"}}>
                        <span>
                            <span class="icon-location">&nbsp;</span>
                            {props.lang.address_label}
                        </span>
                    </List.Item>

                    <List.Item style={{marginBottom: "6px"}}>
                        <span>
                            <span class="icon-phone">&nbsp;</span>
                            {props.lang.phone_label}
                        </span>
                    </List.Item>

                    <List.Item style={{marginBottom: "6px"}}>
                        <span style={{cursor: "pointer"}} onClick={() => window.location.href = `mailto://${props.lang.mail_label}`}>
                            <span class="icon-mail">&nbsp;</span>
                            {props.lang.mail_label}
                        </span>
                    </List.Item>
                </List>
            </Grid.Row>
        </Grid>
    )
}


// WEBPACK FOOTER //
// ./src/components/content/ContentContainer.jsx